import React, { memo } from 'react';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { Toast } from './hooks/useToast';

const DashboardToast: React.FC<{ toast: Toast | null; onClose: () => void }> = ({ toast, onClose }) => (
  <Snackbar
    key={toast?.key}
    open={Boolean(toast)}
    autoHideDuration={toast?.severity === 'error' ? 6000 : 2500}
    onClose={(_, reason) => reason !== 'clickaway' && onClose()}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
  >
    {toast ? (
      <Alert severity={toast.severity} variant="filled" onClose={onClose} sx={{ alignItems: 'center' }}>
        {toast.message}
      </Alert>
    ) : undefined}
  </Snackbar>
);

export default memo(DashboardToast);
